<template>
  <div>
    <l-tables
      :tableConfig="tableConfig"
      ref="childRef"
      :searchParams="searchData"
      :noCreatText="noCreatText"
      :ImgSrc="nullImg"
      :noSearchTerms="true"
      @tableChange="handleTableHeaderChange"
    ></l-tables>
  </div>
</template>

<script>
import LTables from '@/components/LTables/index.vue'
export default {
  components: {
    LTables
  },
  data() {
    return {
      noCreatText: this.$t('admin.favorites.detail.collections.noData'),
      nullImg: require('@/assets/img/trainningAppointmentListNull.png'),
      keyword: undefined,
      searchData: {
        targetId: this.$route.query.id,
        type: this.$route.query.type
      },
      tableConfig: {
        tableName: '',
        tableColumns: [
          {
            title: this.$t('admin.favorites.detail.collections.columns.index'),
            dataIndex: 'index',
            key: 'index',
            align: 'center',
            width: 80
          },
          {
            title: this.$t('admin.favorites.detail.collections.columns.role'),
            dataIndex: 'role',
            key: 'role',
            align: 'center',
            filterMultiple: false,
            filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
            filters: [
              { text: this.$t('admin.favorites.detail.roles.admin'), value: 'admin' },
              { text: this.$t('admin.favorites.detail.roles.teacher'), value: 'teacher' },
              { text: this.$t('admin.favorites.detail.roles.student'), value: 'student' }
            ]
          },
          {
            title: this.$t('admin.favorites.detail.collections.columns.user'),
            dataIndex: 'userName',
            key: 'userName',
            align: 'center'
          },
          {
            title: this.$t('admin.favorites.detail.collections.columns.collectTime'),
            dataIndex: 'collectTime',
            key: 'collectTime',
            align: 'center',
            sortDirections: ['descend', 'ascend', 'descend'],
            sorter: true
          }
        ],
        tableDeleteTip: {
          title: '确定要删除该评论？',
          content: '删除后无法恢复'
        },
        tablePort: {
          list: '/admin/interactions/collect-list'
        },
        hideRowSelection: true
      },
      filterResult: {}
    }
  },
  mounted() {},
  methods: {
    handleTableHeaderChange([filters, getList, sorter]) {
      let result = {}
      result = {
        userType: filters.role,
        timeOrder: sorter.order
        // ...sorter,
      }
      this.filterResult = result
      getList({ condition: result })
    }
  }
}
</script>

<style lang="less" scoped>
.l-form {
  /deep/ .ant-form-item {
    margin-bottom: 0 !important;
    width: 250px;
    line-height: 30px;
  }
  .ant-form-item-label {
    margin-top: 10px;
  }
}
/deep/ .ant-table-thead > tr > th .anticon-filter,
.ant-table-thead > tr > th .ant-table-filter-icon {
  right: auto !important;
}
.remark_cla {
  max-width: 200px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
/deep/.ant-modal-wrap .ant-modal .ant-input {
  resize: none; /* 禁止用户手动拖动调整大小 */
}
/deep/ .ant-table-filter-dropdown .ant-dropdown-menu {
  max-height: 319px !important;
  overflow-x: auto !important;
}
.marginBottom0 {
  margin-bottom: 0;
}
/deep/ .ant-form-item-children {
  textarea {
    width: 100% !important;
  }
}
</style>
